import { useTranslation } from 'react-i18next'

export const Footer = () => {
  const { t } = useTranslation()

  return (
    <footer className="footer text-white text-xs pt-20">
      <div>{t('footer.disclaimer')}</div>
    </footer>
  )
}
